import { SupportDashboardView } from '../views/support.dashboard/support.dashboard.view';
import { DashboardRoutingModule } from './dashboard.routing.module';

import { OrderReportComponent } from './components/order.report/order.report.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedAppModule } from '../app.module.shared';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TicketsComponent } from './components/tickets/tickets.component';

import { DashboardComponent } from './dashboard/dashboard.component';


@NgModule({
  declarations: [
        SupportDashboardView,
        OrderReportComponent,
        TicketsComponent,
        DashboardComponent,
    ],
    imports: [
        CommonModule,
        SharedAppModule,
        ReactiveFormsModule,
        FormsModule,
        DashboardRoutingModule,
    ]
})
export class DashboardModule { }
